//var path = 'http://localhost:5005/api/';
var path = process.env.REACT_APP_API_PATH;
var userSite = process.env.REACT_APP_USERURL;
var config = {
    register: path,
    usersite: userSite
};

export default config;


// WEBPACK FOOTER //
// ./src/API/DomainName.js